<template>
  <div id="app ">
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive> -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: "app",

  mounted () { },
  methods: {},
};
</script>

<style lang="less">
@import "~assets/css/global.less";
:root {
  /* 主色调系统 */
  --primary-color: #409EFF;
  --primary-light: #66B1FF;
  --primary-dark: #337ECC;
  --primary-bg: #ECF5FF;
  
  /* 辅助色系统 */
  --success-color: #67C23A;
  --warning-color: #E6A23C;
  --error-color: #F56C6C;
  --info-color: #909399;
  
  /* 中性色系统 */
  --text-primary: #303133;
  --text-regular: #606266;
  --text-secondary: #909399;
  --text-placeholder: #C0C4CC;
  --border-base: #DCDFE6;
  --border-light: #E4E7ED;
  --border-lighter: #EBEEF5;
  --bg-base: #F2F6FC;
  --bg-card: #FFFFFF;
  --bg-highlight: #F5F7FA;
  
  /* 原有主题色 */
  --theme-black: #1b1718;
  --theme-grey: #f3f4f8;

  #app {
    max-width: 1920px;
    margin: 0 auto;
  }
}
.hide-upload {
  .el-upload--picture-card {
    display: none;
  }
}
// body {
//   background-image: url(./assets/img/main-ng.png);
//   background-repeat: no-repeat;
//   background-position: right bottom;
//   // margin: 0 15px;
//   overflow-x: hidden;
// }
</style>
